import React, { useState } from 'react';
import { supabase } from './supabase';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('login'); // 'login' | 'reset'
  const [resetMsg, setResetMsg] = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { setError(error.message); setLoading(false); }
  }

  async function handleResetPassword(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin,
    });
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      setResetMsg('✅ Check your email for a password reset link.');
    }
  }

  const logoSvg = (
    <svg width="40" height="50" viewBox="0 0 197 249" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M158.29,177.25c4.37,3.62,3.99,11.25,1.09,14.9-3.48,4.37-9.56,4.58-13.73,1.1l-48.6-40.52-.24,71.04c-.02,5.58-6.19,8.2-10.14,7.99-5.27-.27-9.86-3.75-9.89-9.84l-.29-69.51-47.82,41.21c-4.27,3.68-9.47,3.15-13.56-.41-2.97-2.58-4.95-10.22-.59-13.94l56.23-47.93L15.15,85.99c-4.5-3.67-3.42-10.67-.58-13.96,3.79-4.38,9.86-4.61,14.39-.94l47.62,38.59.09-91.63c0-4.41,1.79-8.05,5.23-9.8,2.94-1.5,7.95-1.51,10.98.9l29.47,23.46c5.92,4.72,10.1,11.62,4.75,18.78-3.06,4.09-9.99,3.9-14.06.58l-16.07-13.13v70.41s46.81-40.03,46.81-40.03l-12.93-12.02,31.27-6.11,22.14-4.2-17.67,53.75-8.72-17.32-55.58,47.57,56,46.38Z" fill="#3D1A6E"/>
    </svg>
  );

  return (
    <div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F6F1E9' }}>
      <div style={{ background: 'white', padding: '48px 40px', borderRadius: 12, boxShadow: '0 4px 24px rgba(61,26,110,0.1)', width: '100%', maxWidth: 400, borderTop: '4px solid #3D1A6E' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          {logoSvg}
          <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '0.12em', color: '#3D1A6E', marginTop: 8 }}>ODINFLOW</div>
          <div style={{ fontSize: 11, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#7B4DBF', marginTop: 2 }}>Travel Distribution Software</div>
        </div>

        {mode === 'login' ? (
          <>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1C1C2E', marginBottom: 24, textAlign: 'center' }}>Sign in to your account</h2>
            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6B6880', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 6 }}>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  style={{ width: '100%', padding: '11px 14px', borderRadius: 6, border: '1.5px solid #EDE5F8', fontSize: 14, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box', color: '#1C1C2E' }}
                  placeholder="you@example.com" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6B6880', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 6 }}>Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                  style={{ width: '100%', padding: '11px 14px', borderRadius: 6, border: '1.5px solid #EDE5F8', fontSize: 14, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box', color: '#1C1C2E' }}
                  placeholder="••••••••" />
              </div>

              <div style={{ textAlign: 'right', marginBottom: 20 }}>
                <button type="button" onClick={() => { setMode('reset'); setError(null); setResetMsg(''); }}
                  style={{ background: 'none', border: 'none', color: '#7B4DBF', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}>
                  Forgot password?
                </button>
              </div>

              {error && (
                <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '10px 14px', borderRadius: 6, fontSize: 13, marginBottom: 16 }}>{error}</div>
              )}

              <button type="submit" disabled={loading}
                style={{ width: '100%', padding: '12px', background: '#3D1A6E', color: 'white', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </form>

            <p style={{ textAlign: 'center', fontSize: 12, color: '#6B6880', marginTop: 24 }}>
              Access is by invitation only. Contact your administrator to request access.
            </p>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1C1C2E', marginBottom: 8, textAlign: 'center' }}>Reset your password</h2>
            <p style={{ fontSize: 13, color: '#6B6880', textAlign: 'center', marginBottom: 24 }}>Enter your email and we'll send you a reset link.</p>

            {resetMsg ? (
              <div style={{ background: '#F0FDF9', color: '#0D9488', padding: '12px 14px', borderRadius: 6, fontSize: 13, marginBottom: 20, textAlign: 'center' }}>{resetMsg}</div>
            ) : (
              <form onSubmit={handleResetPassword}>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#6B6880', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 6 }}>Email</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                    style={{ width: '100%', padding: '11px 14px', borderRadius: 6, border: '1.5px solid #EDE5F8', fontSize: 14, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box', color: '#1C1C2E' }}
                    placeholder="you@example.com" />
                </div>

                {error && (
                  <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '10px 14px', borderRadius: 6, fontSize: 13, marginBottom: 16 }}>{error}</div>
                )}

                <button type="submit" disabled={loading}
                  style={{ width: '100%', padding: '12px', background: '#3D1A6E', color: 'white', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1 }}>
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>
            )}

            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <button type="button" onClick={() => { setMode('login'); setError(null); setResetMsg(''); }}
                style={{ background: 'none', border: 'none', color: '#7B4DBF', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                ← Back to sign in
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Login;